<template>
	<el-dialog top="5vh" :append-to-body="true" title="获取地图点位信息" :visible.sync="dialogVisible" width="1000px">
		<div class="amap-page-container">
			<el-autocomplete
				v-model="state"
				style="width: 100%"
				:fetch-suggestions="querySearchAsync"
				placeholder="请输入搜索地点"
				@select="handleSelect"
				:trigger-on-focus="false"
			></el-autocomplete>
			<el-amap vid="amapDemo" :center="mapInfo.lnglat" :amap-manager="amapManager" :zoom="zoom" :events="events" class="amap-demo" style="height: 500px">
				<el-amap-marker ref="marker" vid="component-marker" :position="mapInfo.lnglat"></el-amap-marker>
			</el-amap>
			<p>标记点：{{ mapInfo.address }}，经度：{{ mapInfo.lng }}，纬度：{{ mapInfo.lat }}</p>
			<div class="dis-flex jus-center"><el-button @click="submit" class="row-btn add" type="primary">确定选择此点位</el-button></div>
		</div>
	</el-dialog>
</template>

<script>
import { AMapManager } from 'vue-amap';
const amapManager = new AMapManager();
export default {
	props: {
		mapPosition: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
		return {
			flag: false,
			addressObj: {},
			dialogVisible: false,
			restaurants: [],
			state: '',
			timeout: null,
			mapInfo: {
				//初始值默认为天安门
				address: '福建省厦门市湖里区江头街道江头(地铁站)福星花园',
				lng: 118.137907,
				lat: 24.49232,
				lnglat: [118.137907, 24.49232]
			},
			zoom: 13,
			amapManager,
			events: {
				click: e => {
					console.log(e);
					this.addressObj.zuobiao = e.lnglat.lng + ',' + e.lnglat.lat;
					this.mapInfo.lng = e.lnglat.lng;
					this.mapInfo.lat = e.lnglat.lat;
					this.mapInfo.lnglat = [e.lnglat.lng, e.lnglat.lat];
					this.getFormattedAddress();
				}
			}
		};
	},
	watch: {
		mapPosition(new1, old) {
			// console.log(new1);
			if (!this.flag) {
				// this.mapInfo.lnglat = new1.lntlat;
				// this.mapInfo.lng = new1.lntlat[0];
				// this.mapInfo.lat = new1.lntlat[1];
				// this.mapInfo.address = new1.formattedAddress;
				this.flag = true;
			}
			this.addressObj.area = new1.addressComponent.district;
			this.addressObj.station = new1.formattedAddress;
			this.addressObj.zuobiao = new1.lntlat[0] + ',' + new1.lntlat[1];
			this.addressObj.address = new1.addressComponent.street;
		}
	},
	methods: {
		submit() {
			this.$emit('onData', this.addressObj);
			this.state = '';
			this.dialogVisible = false;
		},
		// 输入框变化，搜索周边值
		querySearchAsync(queryString, cb) {
			let that = this;
			var MSearch;
			AMap.plugin(['AMap.PlaceSearch'], function() {
				MSearch = new AMap.PlaceSearch({
					//构造地点查询类
					pageSize: 20,
					pageIndex: 1,
					city: '厦门' //城市
				});
				AMap.event.addListener(MSearch, 'complete', keywordSearch_CallBack); //返回地点查询结果
				MSearch.search(queryString); //关键字查询
			});
			function keywordSearch_CallBack(objArr) {
				console.log(objArr);
				if (objArr.info == 'OK') {
					objArr.poiList.pois.forEach((v, k) => {
						that.restaurants[k] = {
							value: v.name,
							address: v.address,
							location: v.location
						};
					});
					cb(that.restaurants);
				}
			}
		},
		// 点击搜索结果中的下拉选项
		handleSelect(item) {
			console.log(item.value);
			this.mapInfo.address = item.value;
			this.mapInfo.lng = item.location.lng;
			this.mapInfo.lat = item.location.lat;
			this.mapInfo.lnglat = [item.location.lng, item.location.lat];
			this.getFormattedAddress('seachClick');
		},
		getFormattedAddress(type) {
			AMap.plugin('AMap.Geocoder', () => {
				let GeocoderOptions = {
					city: '全国',
					extensions: 'all'
				};
				let geocoder = new AMap.Geocoder(GeocoderOptions);
				geocoder.getAddress(this.mapInfo.lnglat, (status, result) => {
					console.log('通过经纬度拿到的地址', result);
					if (status === 'complete' && result.info === 'OK') {
						let addressComponent = result.regeocode.addressComponent;
						// 获取范围内的公交站
						this.getstation(addressComponent.city, this.mapInfo.lng, this.mapInfo.lat).then(res => {
							// console.log(res);
							this.addressObj.luduan = addressComponent.street;
							this.addressObj.station = result.regeocode.formattedAddress;
							this.addressObj.area = addressComponent.district;
							this.addressObj.address = result.regeocode.formattedAddress;
							this.addressObj.province = addressComponent.province;
							this.addressObj.city = addressComponent.city;
							this.addressObj.district = addressComponent.district;
							this.addressObj.longitude = this.mapInfo.lng;
							this.addressObj.latitude = this.mapInfo.lat;
							if(res.length){
								this.addressObj.station = res[0].name
							}
							if (type == 'seachClick') {
								this.addressObj.station = this.mapInfo.address;
								this.addressObj.zuobiao = this.mapInfo.lng + ',' + this.mapInfo.lat;
							} else {
								this.mapInfo.address = res.length ? res[0].name : result.regeocode.formattedAddress;
							}
						});
						
					} else {
						this.mapInfo.address = '无法获取地址';
					}
				});
			});
		},
		//根据城市、经纬度，获取范围内的公交站
		getstation(city, lng, lat) {
			return new Promise((res, rej) => {
				AMap.service(['AMap.PlaceSearch'],function() {
					var placeSearch = new AMap.PlaceSearch({
						// 构造地点查询类
						pageSize: 4,
						typ: '',
						pageIndex: 1,
						city: city // 城市
					});
					placeSearch.searchNearBy('公交站点',[lng, lat],15,function(status, result) {
						if (status === 'complete' && result.info === 'OK') {
							var pois = result.poiList.pois;
							res(pois);
						}else{
							res([]);
						}
					}.bind(this));
				}.bind(this));
			});
		}
		// initMapByInput() {
		//   AMap.plugin("AMap.Autocomplete", () => {
		//     let autoOptions = {
		//       city: "全国",
		//       input: "tipinput",
		//     };
		//     let autoComplete = new AMap.Autocomplete(autoOptions);

		//     AMap.event.addListener(autoComplete, "select", (e) => {
		//       console.log("通过输入拿到的地址", e);
		//       this.mapInfo.lat = e.poi.location.lat;
		//       this.mapInfo.lng = e.poi.location.lng;
		//       this.mapInfo.lnglat = [e.poi.location.lng, e.poi.location.lat];
		//       this.getFormattedAddress();
		//     });
		//   });
		// },
	}
};
</script>

<style lang="scss" scoped>
#tipinput {
	margin-bottom: 10px;
}
.amap-demo {
	height: 500px;
}
.amap-wrapper {
	width: 100%;
	height: 500px;
}
</style>
